export default {
  quantity: {
    system: {
      name: 'quantity',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'quantity',
    rules: {
      title: 'Quantity field',
      required: true,
    }
  },
  price: {
    prefix: '$',
    system: {
      name: 'price',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'price',
    rules: {
      title: 'Price field',
      required: true,
    }
  },
  subtotal: {
    prefix: '$',
    system: {
      name: 'subtotal',
    },
    value: '',
    errors: [],
    type: 'text',
    name: 'subtotal',
    rules: {},
  },
};



// WEBPACK FOOTER //
// ./src/common/SuppliesLogMaterials/fields.js